import React, { useCallback, useMemo } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import UpdateTaxClassificationInfos from 'features/addTeam/UpdateTaxClassificationInfos';
import UpdateTaxClassificationWarnings from 'features/addTeam/UpdateTaxClassificationWarnings';
import { SCROLL_KEYS } from 'features/payroll/constants';

import { cxHelpers } from 'util/className';

import ClassificationSelectInput from './ClassificationSelectInput';
import ContractorTypeSelectInput from './ContractorTypeSelectInput';
import PacketSelectInput from './PacketSelectInput';

const { cx } = cxHelpers('OnboardingPacketRow');

const PacketRow = ({
  errorBorder,
  handleJobTaxClassificationChange,
  jobTaxClassification,
  handleContractorTypeChange,
  contractorType,
  handlePacketChange,
  isPayrollSetup,
  numberOfDocumentsInContractorTemplate,
  numberOfDocumentsInEmployeeTemplate,
  selectedPacket,
  canEditTaxClassification,
  user,
  hasNoActivePayments,
  hasPaidPayrollRunsForJob,
  hasITIN,
  isPayrollUpdating,
}) => {
  const isContractor = useMemo(
    () => jobTaxClassification === '1099',
    [jobTaxClassification]
  );
  const handleClick = useCallback(() => {
    document
      .getElementById(SCROLL_KEYS.payrollHistory.elementId)
      ?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return (
    <div className={cx()}>
      <ClassificationSelectInput
        errorBorder={errorBorder}
        jobTaxClassification={jobTaxClassification}
        canEditTaxClassification={canEditTaxClassification}
        handleJobTaxClassificationChange={handleJobTaxClassificationChange}
      />

      {isContractor && (
        <ContractorTypeSelectInput
          handleContractorTypeChange={handleContractorTypeChange}
          contractorType={contractorType}
          errorBorder={errorBorder || isEmpty(contractorType)}
          hasNoActivePayments={hasNoActivePayments}
        />
      )}

      {isPayrollUpdating && (
        <>
          <UpdateTaxClassificationWarnings
            user={user}
            hasNoActivePayments={hasNoActivePayments}
            onClick={handleClick}
            hasITIN={hasITIN}
          />

          <UpdateTaxClassificationInfos
            user={user}
            hasNoActivePayments={hasNoActivePayments}
            hasITIN={hasITIN}
            hasPaidPayrollRunsForJob={hasPaidPayrollRunsForJob}
          />
        </>
      )}

      {!isPayrollSetup && (
        <PacketSelectInput
          jobTaxClassification={jobTaxClassification}
          selectedPacket={selectedPacket}
          handlePacketChange={handlePacketChange}
          numberOfDocumentsInContractorTemplate={
            numberOfDocumentsInContractorTemplate
          }
          numberOfDocumentsInEmployeeTemplate={
            numberOfDocumentsInEmployeeTemplate
          }
        />
      )}
    </div>
  );
};

PacketRow.propTypes = {
  handleJobTaxClassificationChange: PropTypes.func.isRequired,
  handleContractorTypeChange: PropTypes.func.isRequired,
  jobTaxClassification: PropTypes.string,
  contractorType: PropTypes.string,
  handlePacketChange: PropTypes.func.isRequired,
  handleUploadedDocs: PropTypes.func,
  isPayrollSetup: PropTypes.bool,
  numberOfDocumentsInContractorTemplate: PropTypes.number.isRequired,
  numberOfDocumentsInEmployeeTemplate: PropTypes.number.isRequired,
  selectedPacket: PropTypes.string.isRequired,
  user: ImmutablePropTypes.map,
  canEditTaxClassification: PropTypes.bool,
  hasNoActivePayments: PropTypes.bool,
  hasPaidPayrollRunsForJob: PropTypes.bool,
  hasITIN: PropTypes.bool,
  isPayrollUpdating: PropTypes.bool,
};

export default PacketRow;
